/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationDataConnectionsDriversDriverOutputDtoMeta interface.
 */
export function instanceOfFxIdApplicationDataConnectionsDriversDriverOutputDtoMeta(value) {
    if (!('Name' in value) || value['Name'] === undefined)
        return false;
    if (!('Type' in value) || value['Type'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaFromJSON(json) {
    return FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaFromJSONTyped(json, false);
}
export function FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Name': json['Name'],
        'Type': json['Type'],
    };
}
export function FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaToJSON(json) {
    return FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaToJSONTyped(json, false);
}
export function FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Name': value['Name'],
        'Type': value['Type'],
    };
}
//# sourceMappingURL=FxIdApplicationDataConnectionsDriversDriverOutputDtoMeta.js.map